/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExecutionPlanTaskDto } from './ExecutionPlanTaskDto';
import {
    ExecutionPlanTaskDtoFromJSON,
    ExecutionPlanTaskDtoFromJSONTyped,
    ExecutionPlanTaskDtoToJSON,
    ExecutionPlanTaskDtoToJSONTyped,
} from './ExecutionPlanTaskDto';

/**
 * 
 * @export
 * @interface ExecutionPlanDto
 */
export interface ExecutionPlanDto {
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanDto
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanDto
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanDto
     */
    ownerUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanDto
     */
    boundaryId?: string;
    /**
     * 
     * @type {Date}
     * @memberof ExecutionPlanDto
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ExecutionPlanDto
     */
    targetEndDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ExecutionPlanDto
     */
    actualEndDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof ExecutionPlanDto
     */
    budgetTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecutionPlanDto
     */
    budgetSpent?: number;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanDto
     */
    budgetCurrency?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanDto
     */
    drivenBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof ExecutionPlanDto
     */
    cpaComputedAt?: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExecutionPlanDto
     */
    criticalPathIds?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ExecutionPlanDto
     */
    version?: number;
    /**
     * 
     * @type {Date}
     * @memberof ExecutionPlanDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ExecutionPlanDto
     */
    updatedAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof ExecutionPlanDto
     */
    taskCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecutionPlanDto
     */
    completedTaskCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecutionPlanDto
     */
    completionPct?: number;
    /**
     * 
     * @type {Array<ExecutionPlanTaskDto>}
     * @memberof ExecutionPlanDto
     */
    tasks?: Array<ExecutionPlanTaskDto>;
}

/**
 * Check if a given object implements the ExecutionPlanDto interface.
 */
export function instanceOfExecutionPlanDto(value: object): value is ExecutionPlanDto {
    return true;
}

export function ExecutionPlanDtoFromJSON(json: any): ExecutionPlanDto {
    return ExecutionPlanDtoFromJSONTyped(json, false);
}

export function ExecutionPlanDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecutionPlanDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'status': json['status'] == null ? undefined : json['status'],
        'ownerUserId': json['ownerUserId'] == null ? undefined : json['ownerUserId'],
        'boundaryId': json['boundaryId'] == null ? undefined : json['boundaryId'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'targetEndDate': json['targetEndDate'] == null ? undefined : (new Date(json['targetEndDate'])),
        'actualEndDate': json['actualEndDate'] == null ? undefined : (new Date(json['actualEndDate'])),
        'budgetTotal': json['budgetTotal'] == null ? undefined : json['budgetTotal'],
        'budgetSpent': json['budgetSpent'] == null ? undefined : json['budgetSpent'],
        'budgetCurrency': json['budgetCurrency'] == null ? undefined : json['budgetCurrency'],
        'drivenBy': json['drivenBy'] == null ? undefined : json['drivenBy'],
        'cpaComputedAt': json['cpaComputedAt'] == null ? undefined : (new Date(json['cpaComputedAt'])),
        'criticalPathIds': json['criticalPathIds'] == null ? undefined : json['criticalPathIds'],
        'version': json['version'] == null ? undefined : json['version'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'taskCount': json['taskCount'] == null ? undefined : json['taskCount'],
        'completedTaskCount': json['completedTaskCount'] == null ? undefined : json['completedTaskCount'],
        'completionPct': json['completionPct'] == null ? undefined : json['completionPct'],
        'tasks': json['tasks'] == null ? undefined : ((json['tasks'] as Array<any>).map(ExecutionPlanTaskDtoFromJSON)),
    };
}

export function ExecutionPlanDtoToJSON(json: any): ExecutionPlanDto {
    return ExecutionPlanDtoToJSONTyped(json, false);
}

export function ExecutionPlanDtoToJSONTyped(value?: ExecutionPlanDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'name': value['name'],
        'description': value['description'],
        'status': value['status'],
        'ownerUserId': value['ownerUserId'],
        'boundaryId': value['boundaryId'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString().substring(0,10)),
        'targetEndDate': value['targetEndDate'] == null ? undefined : ((value['targetEndDate']).toISOString().substring(0,10)),
        'actualEndDate': value['actualEndDate'] == null ? undefined : ((value['actualEndDate']).toISOString().substring(0,10)),
        'budgetTotal': value['budgetTotal'],
        'budgetSpent': value['budgetSpent'],
        'budgetCurrency': value['budgetCurrency'],
        'drivenBy': value['drivenBy'],
        'cpaComputedAt': value['cpaComputedAt'] == null ? undefined : ((value['cpaComputedAt']).toISOString()),
        'criticalPathIds': value['criticalPathIds'],
        'version': value['version'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'taskCount': value['taskCount'],
        'completedTaskCount': value['completedTaskCount'],
        'completionPct': value['completionPct'],
        'tasks': value['tasks'] == null ? undefined : ((value['tasks'] as Array<any>).map(ExecutionPlanTaskDtoToJSON)),
    };
}

